import { trackCardUpClick } from '@libs/analytics';
import { getENV } from '@libs/common-next';

import type { CardUpVariantType, LinkAction } from '../../types';
import type { ContentfulOffer } from './types';
import { getOfferCardUpLayout } from './utils';

type TrackCardUpLinkActionClick = {
    header?: string;
    linkAction?: LinkAction;
    offerCount: number;
    pathname: string;
    variant: CardUpVariantType;
};

export const trackCardUpLinkActionClick = ({
    header,
    linkAction,
    offerCount,
    pathname,
    variant,
}: TrackCardUpLinkActionClick) => {
    const baseClick = {
        title: header,
        cardName: linkAction?.actionText,
        cardPosition: -1,
        promoDesc: linkAction?.internalTitle ?? '',
    };

    if (variant !== 'Offer') {
        trackCardUpClick({ ...baseClick, variant });
        return;
    }

    const { containerClassName, trackingVariant } = getOfferCardUpLayout(offerCount);

    trackCardUpClick({
        ...baseClick,
        variant: trackingVariant,
        link: linkAction?.link?.webUrl,
        pathname,
        promoType: containerClassName,
    });
};

type TrackOfferCardClick = {
    header?: string;
    index: number;
    offer: ContentfulOffer;
    offerCount: number;
    pathname?: string;
};

export const trackOfferCardClick = ({ header, index, offer, offerCount, pathname }: TrackOfferCardClick) => {
    const { containerClassName, trackingVariant } = getOfferCardUpLayout(offerCount);
    const isCA = getENV('NEXT_PUBLIC_LOCALE') === 'en-CA';

    trackCardUpClick({
        variant: trackingVariant,
        title: header,
        cardName: offer.shortDescription,
        cardPosition: index + 1,
        link: isCA ? offer.webUrlCa : offer.webUrl,
        pathname,
        promoDesc: offer.internalTitle,
        promoType: containerClassName,
    });
};
